module.exports = __webpack_public_path__ + "img/notifications/play-13e21700e44c72488694b29f965917aa.svg";